<template>
  <div class="vanta" id="vanta" style="position:relative">
    <div class="positw">
      <img :src="fir" alt="Imag" style="height:15vw" />
    </div>
    <div class="positwa">
      <img :src="ball" alt="Imag" style="height:200px" />
    </div>
    <div class="waveWrapper waveAnimation">
      <div class="waveWrapperInner bgTop" style="top:0;">
        <div
          class="wave waveTop"
          style="background-image: url('http://front-end-noobs.com/jecko/img/wave-top.png')"
        ></div>
      </div>
      <div class="waveWrapperInner bgMiddle">
        <div
          class="wave waveMiddle"
          style="background-image: url('http://front-end-noobs.com/jecko/img/wave-mid.png')"
        ></div>
      </div>
      <div class="waveWrapperInner bgBottom">
        <div
          class="wave waveBottom"
          style="background-image: url('http://front-end-noobs.com/jecko/img/wave-bot.png')"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import fir from "./images/fir.png";
import ball from "./images/ball.gif";
export default {
  data() {
    return {
      fir: fir,
      ball: ball,
    };
  },
};
</script>
<style scoped>
@keyframes move_wave {
  0% {
    transform: translateX(0) translateZ(0) scaleY(1);
  }
  50% {
    transform: translateX(-25%) translateZ(0) scaleY(0.55);
  }
  100% {
    transform: translateX(-50%) translateZ(0) scaleY(1);
  }
}
.waveWrapper {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.waveWrapperInner {
  position: absolute;
  width: 100%;
  overflow: hidden;
  height: 100%;
  bottom: -1px;
  background-image: linear-gradient(to top, #86377b 20%, #503361 80%);
}
.bgTop {
  z-index: 15;
  opacity: 0.5;
}
.bgMiddle {
  z-index: 10;
  opacity: 0.75;
}
.bgBottom {
  z-index: 5;
}
.wave {
  position: absolute;
  left: 0;
  width: 200%;
  height: 100%;
  background-repeat: repeat no-repeat;
  background-position: 0 bottom;
  transform-origin: center bottom;
}
.waveTop {
  background-size: 70% 120px;
}
@media screen and (min-width: 750px) {
  .waveTop {
    background-size: 70% 180px;
  }
}
.waveAnimation .waveTop {
  animation: move-wave 3s;
  -webkit-animation: move-wave 3s;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}
.waveMiddle {
  background-size: 50% 130px;
}
@media screen and (min-width: 750px) {
  .waveTop {
    background-size: 70% 190px;
  }
}
.waveAnimation .waveMiddle {
  animation: move_wave 10s linear infinite;
}
.waveBottom {
  background-size: 50% 120px;
}
@media screen and (min-width: 750px) {
  .waveTop {
    background-size: 70% 180px;
  }
}
.waveAnimation .waveBottom {
  animation: move_wave 5s linear infinite;
}
* {
  padding: 0;
  margin: 0;
}
#vanta {
  width: 100%;
  height: 100%;
}
#vanta img {
  width: 100%;
  height: 100%;
}
.positw {
  position: absolute;
  top: 3vh;
  left: 10vw;
  z-index: 10;
}
.positw img {
  height: 200px;
}
.positwa {
  position: absolute;
  top: 2vh;
  right: 3vw;
  z-index: 10;
}
</style>
